import { Configuration } from '../app.constants'
import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'

@Injectable()
export class AdministratorService {
    constructor(private http: HttpClient) {
    }

    saveGlobalBankFeeConfig(model): any {
        return this.http.post(Configuration.apiUrl + 'Api/Admin/saveBankFeeConfig', JSON.stringify(model), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    getGlobalConfig(): any {
        return this.http.get(Configuration.apiUrl + 'Api/Admin/Config')
    }

    saveContent(model): any {
        return this.http.post(Configuration.apiUrl + 'Api/Contents/SaveInboundContent', JSON.stringify(model), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    getContentsList(): any {
        return this.http.get(Configuration.apiUrl + 'Api/Contents/InboundContentsList')
    }

    deleteContent(_id): any {
        return this.http.get(Configuration.apiUrl + 'Api/Contents/DeleteInboundContent?_id=' + _id)
    }

    getCauseIcons(): any {
        return this.http.get(Configuration.apiUrl + 'Api/Customize/AdminGetCauseIcons')
    }

    adminSaveCauseIcons(cause): any {
        return this.http.post(Configuration.apiUrl + 'Api/Customize/AdminSaveCauseIcons', JSON.stringify(cause), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    adminImportExcelConciliation(cause): any {
        return this.http.post(Configuration.apiUrl + 'Api/admin/ImportExcelConciliation', JSON.stringify(cause), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    adminCreateNewHubspotTicket(type, seoUrl, subject, content): any {
        return this.http.get(Configuration.apiUrl + 'Api/admin/CreateNewHubspotTicket?type=' + type + '&seoUrl=' + seoUrl + '&subject=' + subject + '&content=' + content)
    }


    adminCampaigns(): any {
        return this.http.get(Configuration.apiUrl + 'Api/Campaign/AdminDashboard')
    }

    adminRepurchase(): any {
        return this.http.get(Configuration.apiUrl + 'Api/admin/AdminRepurchase?token=ott')
    }

    adminProblemStore(): any {
        return this.http.get(Configuration.apiUrl + 'Api/admin/AdminGetProblemStores')
    }

    adminSaveProblemStore(problem): any {
        return this.http.post(Configuration.apiUrl + 'Api/admin/adminSaveProblemStore', JSON.stringify(problem), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    getAllFeatures(): any {
        return this.http.get(Configuration.apiUrl + 'api/plan/feature/getall')
    }

    saveFeature(cause): any {
        return this.http.post(Configuration.apiUrl + 'api/plan/feature/save', JSON.stringify(cause), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    deleteFeatures(featureId): any {
        return this.http.get(Configuration.apiUrl + 'api/plan/feature/delete?featureId=' + featureId)
    }
}